import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { Collections, FolderSpecial, WorkOutline } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import Edit from '@mui/icons-material/Edit';

import {
  FontName,
  LeftButton,
  RightButton,
  Card,
  IconButtons,
  flexAlignCenterGap,
  flexColumnGap,
} from '../../../utils/common/styles/commonStyles';

const Cards = ({ row, onCardClick, onEditClick, onManageCollection, onManageUsers }) => {
  return (
    <Card onClick={() => onCardClick(row)}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ ...flexAlignCenterGap(1.5) }}>
          <Avatar
            sx={{
              width: 40,
              height: 40,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              boxShadow: '0 4px 14px rgba(102, 126, 234, 0.25)',
              border: '2px solid rgba(255, 255, 255, 0.8)',
            }}
          >
            <FolderSpecial sx={{ color: 'white', fontSize: '1.2rem' }} />
          </Avatar>

          <FontName>{row.name || row.collectionName}</FontName>
        </Box>

        <IconButtons
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onEditClick(row);
          }}
        >
          <Edit fontSize="small" />
        </IconButtons>
      </Box>

      <Box sx={{ mt: 2.5, ...flexColumnGap(1.5) }}>
        {/* Drives */}
        <Box sx={{ ...flexAlignCenterGap(1) }}>
          <Collections sx={{ color: '#10B981', fontSize: '1.1rem' }} />

          <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>
            Drives:
          </Typography>

          <Typography sx={{ fontWeight: 700, color: 'common.black' }}>
            {row.driveCount ?? (Array.isArray(row.drives) ? row.drives.length : 0)}
          </Typography>
        </Box>

        {/* Created By */}
        <Box sx={{ ...flexAlignCenterGap(1) }}>
          <PersonIcon sx={{ color: '#F59E0B', fontSize: '1.1rem' }} />

          <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>
            Created by:
          </Typography>

          <Typography sx={{ fontWeight: 600, color: 'common.black' }}>
            {row.createdByUser?.name || row.createdByName || row.createdBy || '—'}
          </Typography>
        </Box>

        {/* Company */}
        <Box sx={{ ...flexAlignCenterGap(1) }}>
          <WorkOutline sx={{ color: '#8B5CF6', fontSize: '1.1rem' }} />

          <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>
            Company:
          </Typography>

          <Typography sx={{ fontWeight: 600, color: 'common.black' }}>
            {row.companyName || row.company?.companyName || '—'}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ ...flexAlignCenterGap(1.5), mt: 3 }}>
        <LeftButton
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            onManageCollection(row);
          }}
        >
          Manage Collection
        </LeftButton>

        <RightButton
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            onManageUsers(row);
          }}
        >
          Manage User
        </RightButton>
      </Box>
    </Card>
  );
};

export default Cards;

Cards.propTypes = {
  row: PropTypes.object.isRequired,
  onCardClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onManageCollection: PropTypes.func.isRequired,
  onManageUsers: PropTypes.func.isRequired,
};
